module.exports = __webpack_public_path__ + "static/media/Mixed.e3e7b430.jpg";